import { createFeatureSelector, createSelector } from "@ngrx/store";

import { metricsFeatureKey, MetricsState } from "./metrics.reducer";

export const selectMetricsState =
  createFeatureSelector<MetricsState>(metricsFeatureKey);

export const selectMetrics = createSelector(
  selectMetricsState,
  state => state.metrics
);

export const selectMetricsError = createSelector(
  selectMetricsState,
  state => state.error
);

export const selectTimeSeriesData = createSelector(
  selectMetricsState,
  state => state.timeSeriesData
);

export const selectSelectedProducts = createSelector(
  selectMetricsState,
  state => state.selectedProducts
);

export const selectSelectedRequestTypes = createSelector(
  selectMetricsState,
  state => state.selectedRequestTypes
);
